import { Component, OnInit } from '@angular/core'
import {
  RootState,
  SessionWithState,
  selectActiveSession,
  selectUsingLocalStorage,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { debounceTime, map } from 'rxjs/operators'
import { HeliosMessagingService } from '../../services/helios-messaging/helios-messaging.service'

@Component({
  selector: 'hs-messaging-status-footer',
  templateUrl: './messaging-status-footer.component.html',
  styleUrls: ['./messaging-status-footer.component.scss'],
})
export class MessagingStatusFooterComponent implements OnInit {
  activeSession?: SessionWithState
  usingLocalStorage$ = this.store.select(selectUsingLocalStorage)
  usingLocalStorageTooltip$ = this.usingLocalStorage$.pipe(
    map(
      usingLocalStorage =>
        `User preferences being stored ${
          usingLocalStorage ? 'locally.' : 'in the cloud.'
        }`,
    ),
  )

  /**
   * Track the global socket connection status
   */
  globalSocketConnected = true

  constructor(
    private readonly store: Store<RootState>,
    public messaging: HeliosMessagingService,
  ) {}

  ngOnInit(): void {
    this.store
      .select(selectActiveSession)
      .subscribe(session => (this.activeSession = session))

    /**
     * Subscribe to changes in the global socket connection status
     */
    this.messaging.isGlobalConnected$
      .pipe(
        debounceTime(20000), // Debounce to prevent flickering
      )
      .subscribe(status => {
        this.globalSocketConnected = status
      })
  }
}
